import { defineMessages } from 'react-intl.macro';

import { DtmDataTypeEnum } from '../../openapi/types/DtmDataTypeEnum';
import { UtilitiesTypeEnum } from '../../openapi/types/UtilitiesTypeEnum';
import { PrejimkaTypesEnum } from '../../openapi/types/PrejimkaTypesEnum';
import { TypySubjektuEnum } from '../../openapi/types/TypySubjektuEnum';
import { SvuCrossNames } from '../../openapi/types/SvuCrossNames';

import type { DocFormTypes } from '../constants';
import {
  REJECTION_REASON,
  DOCUMENTATION_TYPES,
  DATA_ORIGIN_TYPES,
  ATTACHMENT_TYPES,
  DOC_STATE,
} from '../constants';

export const docListMessages = defineMessages({
  docListPageTitle: {
    id: 'docList.page.title',
    defaultMessage: 'Přehled dokumentací',
  },
  docListStateWaiting: {
    id: 'docList.state.waiting',
    defaultMessage: 'Seznam dokumentací se načítá.',
  },
  docListStateFail: {
    id: 'docList.state.fail',
    defaultMessage: 'Seznam dokumentací se nepovedlo načíst.',
  },
  docListStateEmpty: {
    id: 'docList.state.empty',
    defaultMessage: 'Seznam dokumentací je prázdný.',
  },
  docListFiltrLabel: {
    id: 'docList.label.filter',
    defaultMessage: 'Filtr',
  },
  docListExportCsvLabel: {
    id: 'docList.label.exportCsv',
    defaultMessage: 'Export do CSV',
  },
  docListStateFilteredEmpty: {
    id: 'docList.state.filteredEmpty',
    defaultMessage: 'Zadanému filtru neodpovídá žádný záznam.',
  },
  docListColumnState: {
    id: 'docList.column.state',
    defaultMessage: 'Stav',
  },
  docListColumnNumber: {
    id: 'docList.column.number',
    defaultMessage: 'Číslo',
  },
  docListColumnDocType: {
    id: 'docList.column.docType',
    defaultMessage: 'Typ změny',
  },
  docListColumnPrejimkaType: {
    id: 'docForm.receiveType',
    defaultMessage: 'Typ příjmu',
  },
  docListColumnName: {
    id: 'docList.column.name',
    defaultMessage: 'Název',
  },
  docListColumnDescription: {
    id: 'docList.column.description',
    defaultMessage: 'Popis',
  },
  docListColumnCadaster: {
    id: 'docList.column.cadaster',
    defaultMessage: 'Katastr',
  },
  docListColumnOwner: {
    id: 'docList.column.owner',
    defaultMessage: 'Vlastník / investor',
  },
  docListColumnAuthor: {
    id: 'docList.column.author',
    defaultMessage: 'Zpracovatel',
  },
  docListColumnUser: {
    id: 'docList.column.user',
    defaultMessage: 'Uživatel',
  },
  docListColumnSubjekt: {
    id: 'docList.column.subjekt',
    defaultMessage: 'Subjekt',
  },
  docListColumnReceiver: {
    id: 'docList.column.receiver',
    defaultMessage: 'Příjemce',
  },
  docListColumnGeodesist: {
    id: 'docList.column.geodesist',
    defaultMessage: 'Geodet',
  },
  docListColumnCreated: {
    id: 'docList.column.Created',
    defaultMessage: 'Podáno',
  },
  docListColumnDtmkCreated: {
    id: 'docList.column.dtmkCreated',
    defaultMessage: 'Vytvořeno',
  },
  docListColumnAccepted: {
    id: 'docList.column.accepted',
    defaultMessage: 'Přijato',
  },
  docListColumnClosed: {
    id: 'docList.column.closed',
    defaultMessage: 'Ukončeno',
  },
  docListColumnGpClosed: {
    id: 'docList.column.gpClosed',
    defaultMessage: 'Uzavřeno',
  },
  docListColumnEditorManager: {
    id: 'docList.column.editorManager',
    defaultMessage: 'Editor',
  },
  docListColumnResponsiblePerson: {
    id: 'docList.column.responsiblePerson',
    defaultMessage: 'Zodpovědná osoba',
  },
  docListColumnDmvsIdPodani: {
    id: 'docList.column.dmvsIdPodani',
    defaultMessage: 'ID podání',
  },
  docListColumnDmvsSource: {
    id: 'docList.column.dmvsSource',
    defaultMessage: 'Zdroj dokumentace',
  },
  docListColumnSvu: {
    id: 'docList.column.svu',
    defaultMessage: 'SVÚ / Kraj',
  },
  docListImportExternalDocs: {
    id: 'docList.importExternalDocs',
    defaultMessage: 'Import dokumentací DTM',
  },
});

export const docInternalInfoMessages = defineMessages({
  title: {
    id: 'docInternalInfo.title',
    defaultMessage: 'Interní záznam kraje',
  },
  responsiblePerson: {
    id: 'docInternalInfo.responsiblePerson',
    defaultMessage: 'Zodpovědná osoba',
  },
  internalNote: {
    id: 'docInternalInfo.internalNote',
    defaultMessage: 'Interní poznámka',
  },
  internalNoteHint: {
    id: 'docInternalInfo.internalNoteHint',
    defaultMessage:
      'Vidí jen uživatelé kraje. Nedostane se do protokolu o předání ani do zpráv pro ČÚZK.',
  },
  save: {
    id: 'docInternalInfo.save',
    defaultMessage: 'Uložit interní záznam',
  },
  saveSuccess: {
    id: 'docInternalInfo.saveSuccess',
    defaultMessage: 'Záznam byl uložen.',
  },
  saveFail: {
    id: 'docInternalInfo.saveFail',
    defaultMessage: 'Záznam se nepodařilo uložit.',
  },
});

export const checkListMessages = defineMessages({
  checkListPageTitle: {
    id: 'checkList.page.title',
    defaultMessage: 'Přehled Kontrol',
  },
  checkListStateWaiting: {
    id: 'checkList.state.waiting',
    defaultMessage: 'Seznam kontrol se načítá.',
  },
  checkListStateFail: {
    id: 'checkList.state.fail',
    defaultMessage: 'Seznam kontrol se nepovedlo načíst.',
  },
  checkListStateEmpty: {
    id: 'checkList.state.empty',
    defaultMessage: 'Seznam kontrol je prázdný.',
  },
  checkListFiltrLabel: {
    id: 'checkList.label.filter',
    defaultMessage: 'Filtr',
  },
  checkListExportCsvLabel: {
    id: 'checkList.label.exportCsv',
    defaultMessage: 'Export do CSV',
  },
  checkListStateFilteredEmpty: {
    id: 'checkList.state.filteredEmpty',
    defaultMessage: 'Zadanému filtru neodpovídá žádný záznam.',
  },
  checkListColumnState: {
    id: 'checkList.column.state',
    defaultMessage: 'Stav',
  },
  checkListColumnNumber: {
    id: 'checkList.column.number',
    defaultMessage: 'Číslo',
  },
  checkListColumnName: {
    id: 'checkList.column.name',
    defaultMessage: 'Název',
  },
  checkListColumnAuthor: {
    id: 'checkList.column.author',
    defaultMessage: 'Zpracovatel',
  },
  checkListColumnCreated: {
    id: 'checkList.column.created',
    defaultMessage: 'Vytvořeno',
  },
  checkListColumnCheckSource: {
    id: 'checkList.column.checkSource',
    defaultMessage: 'Zdroj kontroly',
  },
  checkListColumnDmvsIdPodani: {
    id: 'checkList.column.dmvsIdPodani',
    defaultMessage: 'ID podání',
  },
  checkListColumnGeodesist: {
    id: 'checkList.column.geodesist',
    defaultMessage: 'Geodet',
  },
});

export const rejectionReasonMessages = defineMessages<REJECTION_REASON | 'null'>({
  null: {
    id: 'doc.rejection.reason.null',
    defaultMessage: ' ',
  },
  [REJECTION_REASON.ATTRIBUTE_ATTACHMENT_MISMATCH]: {
    id: 'doc.rejection.reason.attributeAttachmentMismatch',
    defaultMessage: 'Nekorektní příloha',
  },
  [REJECTION_REASON.INSUFFICIENT_SURVEYING]: {
    id: 'doc.rejection.reason.insufficientSurveying',
    defaultMessage: 'Nedostatečné zaměření',
  },
  [REJECTION_REASON.OTHER]: {
    id: 'doc.rejection.reason.other',
    defaultMessage: 'Jiné',
  },
  [REJECTION_REASON.AZI_CHECK_FAILED]: {
    id: 'doc.rejection.reason.aziCheckFailed',
    defaultMessage: 'Neproběhlo ověření AZI',
  },
  [REJECTION_REASON.BAD_ATTACHMENT]: {
    id: 'doc.rejection.reason.badAttachment',
    defaultMessage: 'Nekorektní příloha',
  },
  [REJECTION_REASON.INCOMPLETE_DOCUMENTATION]: {
    id: 'doc.rejection.reason.incompleteDocumentation',
    defaultMessage: 'Nekompletní dokumentace',
  },
});

export const rejectionMessages = defineMessages({
  reasonTitle: {
    id: 'doc.rejection.reasonTitle',
    defaultMessage: 'Důvod odmítnutí',
  },
  descriptionTitle: {
    id: 'doc.rejection.descriptionTitle',
    defaultMessage: 'Upřesnění',
  },
  btnCancel: {
    id: 'doc.rejection.btn.cancel',
    defaultMessage: 'Zrušit',
  },
  btnSubmit: {
    id: 'doc.rejection.btn.submit',
    defaultMessage: 'Potvrdit',
  },
  alertFail: {
    id: 'doc.rejection.alert.fail',
    defaultMessage: 'Odmítnutí přejímky se nepovedlo. Zkuste to prosím později.',
  },
  alertWaiting: {
    id: 'doc.rejection.alert.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
});

export const docTitleMessages = defineMessages<DocFormTypes>({
  check: {
    id: 'doc.title.check',
    defaultMessage:
      '{id, select, new {Kontrola dokumentace} empty {Kontrola dokumentace} other {Kontrola dokumentace č. {id}}}',
  },
  doc: {
    id: 'doc.title.doc',
    defaultMessage: '{id, select, new {Nová přejímka} empty {Přejímka} other {Přejímka č. {id}}}',
  },
  initialImport: {
    id: 'doc.title.initialImport',
    defaultMessage:
      '{id, select, new {Prvotní import dat} empty {Prvotní import dat} other {Prvotní import dat č. {id}}}',
  },
  podaniDTI: {
    id: 'doc.title.podaniDTI',
    defaultMessage: '{id, select, new {Podání DTI} empty {Podání DTI} other {Podání DTI č. {id}}}',
  },
  dmvsDti: {
    id: 'doc.title.dmvsDti',
    defaultMessage: '{id, select, empty {Příjem prvků DTI} other {Příjem prvků DTI č. {id}}}',
  },
  dmvsGad: {
    id: 'doc.title.dmvsGad',
    defaultMessage: '{id, select, empty {Příjem prvků GAD} other {Příjem prvků GAD č. {id}}}',
  },
  cepro: {
    id: 'doc.title.cepro',
    defaultMessage:
      '{id, select, new {Příjem prvků ČEPRO} empty {Příjem prvků ČEPRO} other {Příjem prvků ČEPRO č. {id}}}',
  },
  bb: {
    id: 'doc.title.bb',
    defaultMessage:
      '{id, select, new {Příjem prvků} empty {Příjem prvků} other {Příjem prvků č. {id}}}',
  },
  podaniKAD: {
    id: 'doc.title.podaniKad',
    defaultMessage: '{id, select, new {Podání KAD} empty {Podání KAD} other {Podání KAD č. {id}}}',
  },
});

export const documentationTypesMessages = defineMessages<DOCUMENTATION_TYPES | 'null'>({
  null: {
    id: 'doc.documentationtypes.null',
    defaultMessage: ' ',
  },
  [DOCUMENTATION_TYPES.DSPS]: {
    id: 'doc.documentationtypes.DSPS',
    defaultMessage: 'DSPS',
  },
  [DOCUMENTATION_TYPES.GP]: {
    id: 'doc.documentationtypes.GP',
    defaultMessage: 'GP',
  },
  [DOCUMENTATION_TYPES.SURVEYING]: {
    id: 'doc.documentationtypes.SURVEYING',
    defaultMessage: 'Plošné doměření',
  },
});

export const checkTypesMessages = defineMessages<DtmDataTypeEnum | 'null'>({
  null: {
    id: 'doc.checktypes.null',
    defaultMessage: ' ',
  },
  [DtmDataTypeEnum.TI]: {
    id: 'doc.checktypes.TI',
    defaultMessage: 'Technická infrastruktura',
  },
  [DtmDataTypeEnum.DI]: {
    id: 'doc.checktypes.DI',
    defaultMessage: 'Dopravní infrastruktura',
  },
  [DtmDataTypeEnum.ZPS]: {
    id: 'doc.checktypes.ZPS',
    defaultMessage: 'Základní prostorová situace',
  },
});

export const dtmDocumentationTypesMessages = defineMessages<DtmDataTypeEnum>({
  [DtmDataTypeEnum.DI]: {
    id: 'doc.dtmdocumentationtype.DI',
    defaultMessage: 'DI',
  },
  [DtmDataTypeEnum.TI]: {
    id: 'doc.dtmdocumentationtype.TI',
    defaultMessage: 'TI',
  },
  [DtmDataTypeEnum.ZPS]: {
    id: 'doc.dtmdocumentationtype.ZPS',
    defaultMessage: 'ZPS',
  },
});

export const dataOriginTypesMessages = defineMessages<DATA_ORIGIN_TYPES | 'null'>({
  null: {
    id: 'doc.dataorigintypes.null',
    defaultMessage: ' ',
  },
  [DATA_ORIGIN_TYPES.GEODETIC_SURVEYING]: {
    id: 'doc.dataorigintypes.GEODETIC_SURVEYING',
    defaultMessage: 'Geodetické měření',
  },
  [DATA_ORIGIN_TYPES.LASER_SCANNING]: {
    id: 'doc.dataorigintypes.LASER_SCANNING',
    defaultMessage: 'Laserové skenování',
  },
  [DATA_ORIGIN_TYPES.PHOTOGRAMMETRY]: {
    id: 'doc.dataorigintypes.PHOTOGRAMMETRY',
    defaultMessage: 'Fotogrammetrie',
  },
});

export const prejimkaTypesMessages = defineMessages<PrejimkaTypesEnum>({
  [PrejimkaTypesEnum.CHECK]: {
    id: 'doc.prejimkaTypes.check',
    defaultMessage: 'DTMK DTI',
  },
  [PrejimkaTypesEnum.DTM]: {
    id: 'doc.prejimkaTypes.dtm',
    defaultMessage: 'DTMK DTI',
  },
  [PrejimkaTypesEnum.INITIAL_IMPORT]: {
    id: 'doc.prejimkaTypes.initial_import',
    defaultMessage: 'Prvotní import',
  },
  [PrejimkaTypesEnum.GP]: {
    id: 'doc.prejimkaTypes.gp',
    defaultMessage: 'GP',
  },
  [PrejimkaTypesEnum.DMVS_DTI]: {
    id: 'doc.prejimkaTypes.dmvsDti',
    defaultMessage: 'DMVS DTI',
  },
  [PrejimkaTypesEnum.DMVS_GAD]: {
    id: 'doc.prejimkaTypes.dmvsGad',
    defaultMessage: 'DMVS GAD',
  },
  [PrejimkaTypesEnum.DMVS_GAD_CHECK]: {
    id: 'doc.prejimkaTypes.dmvsGadCheck',
    defaultMessage: 'IS DMVS',
  },
  [PrejimkaTypesEnum.CEPRO_IMPORT]: {
    id: 'doc.prejimkaTypes.ceproImport',
    defaultMessage: 'ČEPRO',
  },
  [PrejimkaTypesEnum.BB_IMPORT]: {
    id: 'doc.prejimkaTypes.bbImport',
    defaultMessage: 'Banská Bystrica',
  },
  [PrejimkaTypesEnum.DTM_KAD]: {
    id: 'doc.prejimkaTypes.dtmKad',
    defaultMessage: 'DTM KAD',
  },
});

export const attachmentTypesMessages = defineMessages<ATTACHMENT_TYPES>({
  [ATTACHMENT_TYPES.OTHER]: {
    id: 'doc.attachmentTypes.OTHER',
    defaultMessage: 'Ostatní',
  },
  [ATTACHMENT_TYPES.UPDATE_DATA]: {
    id: 'doc.attachmentTypes.UPDATE_DATA',
    defaultMessage: 'Aktualizační data',
  },
  [ATTACHMENT_TYPES.REFERENCE_DATA]: {
    id: 'doc.attachmentTypes.REFERENCE_DATA',
    defaultMessage: 'Referenční data',
  },
  [ATTACHMENT_TYPES.UPDATE_DATA_RANGE]: {
    id: 'doc.attachmentTypes.UPDATE_DATA_RANGE',
    defaultMessage: 'Rozsah aktualizačních dat',
  },
  [ATTACHMENT_TYPES.DERIVED_DATA_RANGE]: {
    id: 'doc.attachmentTypes.DERIVED_DATA_RANGE',
    defaultMessage: 'Rozsah odvozených dat',
  },
  [ATTACHMENT_TYPES.METADATA]: {
    id: 'doc.attachmentTypes.METADATA',
    defaultMessage: 'Metadata',
  },
  [ATTACHMENT_TYPES.ROZSAH_EDITACE]: {
    id: 'doc.attachmentTypes.ROZSAH_EDITACE',
    defaultMessage: 'Rozsah editace',
  },
  [ATTACHMENT_TYPES.SYNCHRONIZACNI_DATA_SOUSEDNIHO_KRAJE]: {
    id: 'doc.attachmentTypes.SYNCHRONIZACNI_DATA_SOUSEDNIHO_KRAJE',
    defaultMessage: 'Synchronizační data',
  },
  [ATTACHMENT_TYPES.ZAPRACOVANA_DATA_PRESHRANICNI_EDITACE]: {
    id: 'doc.attachmentTypes.ZAPRACOVANA_DATA_PRESHRANICNI_EDITACE',
    defaultMessage: 'Data přeshraniční editace',
  },
  [ATTACHMENT_TYPES.DVOJICE_IDENTIFIKATORU]: {
    id: 'doc.attachmentTypes.DVOJICE_IDENTIFIKATORU',
    defaultMessage: 'Dvojice identifikátorů',
  },
});

export const docStateMessages = defineMessages<DOC_STATE>({
  [DOC_STATE.ACCEPTED]: {
    id: 'document.state.accepted',
    defaultMessage: 'Přijatá',
  },
  [DOC_STATE.CANCELED]: {
    id: 'document.state.canceled',
    defaultMessage: 'Stornovaná',
  },
  [DOC_STATE.CLOSED]: {
    id: 'document.state.closed',
    defaultMessage:
      '{id, select, SVU_OWNER {Uzavřená dokumentace SVÚ} SVU_WORKER {Uzavřená dokumentace SVÚ} other {Uzavřená}}',
  },
  [DOC_STATE.CLOSED_FINAL]: {
    id: 'document.state.closedFinal',
    defaultMessage: 'Uzavřená',
  },
  [DOC_STATE.CLOSE_CHECKS_FAILED]: {
    id: 'document.state.closeChecksFailed',
    defaultMessage:
      '{id, select, INITIAL_IMPORT {Uzavření dokončeno s chybou kontrol} DTM {Uzavření dokončeno s chybou kontrol} other {Uzavření dokončeno s chybou}}',
  },
  [DOC_STATE.CLOSE_FAILED]: {
    id: 'document.state.closeFailed',
    defaultMessage:
      '{id, select, CROSS {Selhalo uzavření} CEPRO_IMPORT {Selhalo uzavření} SVU_OWNER {Selhalo uzavření dokumentace SVÚ} SVU_WORKER {Selhalo uzavření dokumentace SVÚ} other {Uzavření neproběhlo}}',
  },
  [DOC_STATE.CLOSE_FINAL_FAILED]: {
    id: 'document.state.closeFailedFinal',
    defaultMessage: 'Zapracování dvojic identifikátorů neproběhlo',
  },
  [DOC_STATE.CLOSE_INTERRUPTED]: {
    id: 'document.state.closeInterrupted',
    defaultMessage: 'Uzavírání přerušeno',
  },
  [DOC_STATE.CLOSING_READY_TO_SEND_TO_DMVS]: {
    id: 'document.state.closingReadyToSendToDMVS',
    defaultMessage: 'K odeslání do IS DMVS',
  },
  [DOC_STATE.CLOSING]: {
    id: 'document.state.closing',
    defaultMessage:
      '{id, select, SVU_OWNER {Probíhá uzavření dokumentace SVÚ} SVU_WORKER {Probíhá uzavření dokumentace SVÚ} other {Probíhá uzavření}}',
  },
  [DOC_STATE.CLOSING_FINAL]: {
    id: 'document.state.closingFinal',
    defaultMessage: 'Probíhá zapracování dvojic identifikátorů',
  },
  [DOC_STATE.DELEGATE_FAILED]: {
    id: 'document.state.delegateFailed',
    defaultMessage: 'Selhalo delegování na SVÚ',
  },
  [DOC_STATE.DELEGATED]: {
    id: 'document.state.delegated',
    defaultMessage: 'Delegováno na SVÚ',
  },
  [DOC_STATE.DELEGATE_REJECTED]: {
    id: 'document.state.delegateRejected',
    defaultMessage: 'Odmítnutá delegace',
  },
  [DOC_STATE.DMVS_COMMUNICATION_FAILED]: {
    id: 'document.state.dmvsCommunicationFailed',
    defaultMessage: 'Selhala komunikace s IS DMVS',
  },
  [DOC_STATE.DRAFT]: {
    id: 'document.state.draft',
    defaultMessage: 'Draft',
  },
  [DOC_STATE.DRAFT_CHECKED]: {
    id: 'document.state.draft_checked',
    defaultMessage: 'Zkontrolovaná',
  },
  [DOC_STATE.EDIT_REJECTED]: {
    id: 'document.state.editRejected',
    defaultMessage: 'Odmítnutá (editace)',
  },
  [DOC_STATE.EDIT_SUPERVISING]: {
    id: 'document.state.editSupervising',
    defaultMessage: 'Kontrola',
  },
  [DOC_STATE.EDIT_TAKEOVER_REJECTED]: {
    id: 'document.state.editTakeoverRejected',
    defaultMessage: 'Odmítnuto převzetí editace',
  },
  [DOC_STATE.EDITING]: {
    id: 'document.state.editing',
    defaultMessage: 'Probíhá editace',
  },
  [DOC_STATE.FAILED_TO_GET_SYNCHRONIZE_DATA]: {
    id: 'document.state.failedToGetSynchronizeData',
    defaultMessage: 'Selhalo získání synchronizačních dat',
  },
  [DOC_STATE.FAILED_TO_SEND_SYNCHRONIZE_DATA]: {
    id: 'document.state.failedToSendSynchronizeData',
    defaultMessage: 'Selhalo odeslání žádosti o synchronizační data',
  },
  [DOC_STATE.CHECKING_SVU_CROSS_KRAJ]: {
    id: 'document.state.checkingSvuCrossKraj',
    defaultMessage: 'Probíhá kontrola PE s krajem',
  },
  [DOC_STATE.CHECK_SVU_CROSS_KRAJ_FAILED]: {
    id: 'document.state.checkSvuCrossKrajFailed',
    defaultMessage: 'Selhala kontrola PE s krajem',
  },
  [DOC_STATE.IMPORT_FAILED]: {
    id: 'document.state.importFailed',
    defaultMessage:
      '{id, select, INITIAL_IMPORT {Chyba importu} CEPRO_IMPORT {Chyba importu} SVU_OWNER {Selhal import přeshraniční dokumentace SVÚ} SVU_WORKER {Selhal import přeshraniční dokumentace SVÚ} other {Import neproběhl}}',
  },
  [DOC_STATE.IMPORT_INTERRUPTED]: {
    id: 'document.state.importInterrupted',
    defaultMessage: 'Import přerušen',
  },
  [DOC_STATE.IMPORTED]: {
    id: 'document.state.imported',
    defaultMessage: 'Import dokončen v pořádku',
  },
  [DOC_STATE.IMPORTED_WITH_ERRORS]: {
    id: 'document.state.importedWithErrors',
    defaultMessage: 'Import dokončen s chybou',
  },
  [DOC_STATE.IMPORTING]: {
    id: 'document.state.importing',
    defaultMessage: 'Probíhá import',
  },
  [DOC_STATE.INPROGRESS]: {
    id: 'document.state.inProgress',
    defaultMessage:
      '{id, select, INITIAL_IMPORT {Rozpracovaný prvotní import} other {Rozpracovaná}}',
  },
  [DOC_STATE.NOTIFYING_CLOSED]: {
    id: 'document.state.notifyingClosed',
    defaultMessage: 'Zapracování dvojic identifikátorů',
  },
  [DOC_STATE.NOTIFYING_CLOSE]: {
    id: 'document.state.notifyingClose',
    defaultMessage:
      '{id, select, DTM {Probíhá odesílání do IS DMVS} CEPRO_IMPORT {Probíhá odesílání do IS DMVS} SVU_OWNER {Probíhá uzavření dokumentace SVÚ - krok II} other {Probíhá uzavření}}',
  },
  [DOC_STATE.NOTIFYING_CLOSE_FAILED]: {
    id: 'document.state.notifyingCloseFailed',
    defaultMessage:
      '{id, select, DTM {Selhalo odeslání do IS DMVS} DMVS_GAD {Selhalo odeslání do IS DMVS} CEPRO_IMPORT {Selhalo odeslání do IS DMVS} SVU_OWNER {Selhalo uzavření dokumentace SVÚ - krok II} other {Selhal průběh uzavření}}',
  },
  [DOC_STATE.PREPARING_FOR_EDIT]: {
    id: 'document.state.preparingForEdit',
    defaultMessage: 'Import dokončen v pořádku',
  },
  [DOC_STATE.PREPARING_FOR_EDIT_WITH_ERRORS]: {
    id: 'document.state.preparingForEditWithErrors',
    defaultMessage: 'Import dokončen s chybou',
  },
  [DOC_STATE.PROCESS_FAILED]: {
    id: 'document.state.processFailed',
    defaultMessage: 'Selhalo uzavření',
  },
  [DOC_STATE.PROCESSED]: {
    id: 'document.state.processed',
    defaultMessage: 'K předání informace o uzavření',
  },
  [DOC_STATE.PROCESSED_SENT_TO_COUNTERPART]: {
    id: 'document.state.processedSentToCounterpart',
    defaultMessage: 'Čeká na uzavření druhou stranou',
  },
  [DOC_STATE.PROCESSING]: {
    id: 'document.state.processing',
    defaultMessage: 'Probíhá uzavření',
  },
  [DOC_STATE.READY_TO_CHECK_SVU_CROSS_KRAJ]: {
    id: 'document.state.readyToCheck',
    defaultMessage: 'Kontrola přeshraniční editace s krajem',
  },
  [DOC_STATE.READY_TO_IMPORT]: {
    id: 'document.state.readyToImport',
    defaultMessage: 'Nová přeshraniční dokumentace SVÚ - krok II',
  },
  [DOC_STATE.READY_TO_PROCESS]: {
    id: 'document.state.readyToProcess',
    defaultMessage:
      '{id, select, CROSS {Připraveno k uzavření} CROSS_WORKER {Připraveno k uzavření - kraj B} SVU_OWNER {Připraveno k uzavření} SVU_WORKER {Připraveno k zapracování dat SVÚ} other {Připraveno k uzavření}}',
  },
  [DOC_STATE.READY_TO_SEND_TO_DMVS]: {
    id: 'document.state.readyToSendToDMVS',
    defaultMessage: 'K odeslání do IS DMVS',
  },
  [DOC_STATE.READY_TO_SYNCHRONIZE]: {
    id: 'document.state.readyToSynchronize',
    defaultMessage: 'Připraveno k synchronizaci',
  },
  [DOC_STATE.REJECTED]: {
    id: 'document.state.rejected',
    defaultMessage: 'Odmítnutá',
  },
  [DOC_STATE.SEND_TO_DMVS_FAILED]: {
    id: 'document.state.sendToDmvsFailed',
    defaultMessage: 'Selhalo odeslání do IS DMVS',
  },
  [DOC_STATE.SEND_TO_COUNTERPART_FAILED]: {
    id: 'document.state.sendToCounterpartFailed',
    defaultMessage:
      '{id, select, CROSS {Selhalo odeslání protistraně} CROSS_OWNER {Selhalo odeslání dokumentace SVÚ do IS DMVS} other {Selhalo odeslání na SVÚ}}',
  },
  [DOC_STATE.SENDING_TO_DMVS]: {
    id: 'document.state.sendingToDmvs',
    defaultMessage: 'Probíhá odeslání do IS DMVS',
  },
  [DOC_STATE.SENDING_TO_COUNTERPART]: {
    id: 'document.state.sendingToCounterpart',
    defaultMessage: 'Probíhá odeslání na SVÚ',
  },
  [DOC_STATE.SENT_TO_COUNTERPART]: {
    id: 'document.state.sentToCounterpart',
    defaultMessage:
      '{id, select, CROSS {Čeká na výsledek protistrany} CROSS_OWNER {Čeká na výsledek importu kraje B} CROSS_WORKER {Čeká na výsledek uzavření kraje A} SVU_OWNER {Probíhá zapracování dokumentace SVÚ - Krok I} SVU_WORKER {Probíhá odeslání na SVÚ} other {Čeká na uzavření protistranou}}',
  },
  [DOC_STATE.SENT_TO_DMVS]: {
    id: 'document.state.sentToDMVS',
    defaultMessage: 'Odesláno do IS DMVS',
  },
  [DOC_STATE.SIGNING]: {
    id: 'document.state.signing',
    defaultMessage: 'K podpisu',
  },
  [DOC_STATE.SIGNED]: {
    id: 'document.state.signed',
    defaultMessage: 'Podepsáno',
  },
  [DOC_STATE.SIGNED_FAILED]: {
    id: 'document.state.signedFailed',
    defaultMessage: 'Selhalo podepisování',
  },
  [DOC_STATE.SUBMITTED]: {
    id: 'document.state.submitted',
    defaultMessage:
      '{id, select, CROSS {Nová přeshraniční dokumentac} CROSS_WORKER {Nová přeshraniční dokumentace - kraj B} SVU_OWNER {Nová přeshraniční dokumentace SVÚ - krok I} other {Nová}}',
  },
  [DOC_STATE.SYNCHRONIZED]: {
    id: 'document.state.synchronized',
    defaultMessage: 'Synchronizace dokončena v pořádku',
  },
  [DOC_STATE.SYNCHRONIZE_FAILED]: {
    id: 'document.state.synchronizeFailed',
    defaultMessage:
      '{id, select, CROSS {Selhala synchronizace přeshraniční dokumentace} CROSS_WORKER {Selhala synchronizace přeshraniční dokumentace} other {Selhala synchronizace}}',
  },
  [DOC_STATE.SYNCHRONIZING]: {
    id: 'document.state.synchronizing',
    defaultMessage: 'Probíhá synchronizace',
  },
  [DOC_STATE.TAKEN_OVER]: {
    id: 'document.state.takenOver',
    defaultMessage: 'Převzato krajem',
  },
  [DOC_STATE.WAITING_FOR_CLOSE]: {
    id: 'document.state.waitingForClose',
    defaultMessage:
      '{id, select, CROSS {Probíhá uzavření} SVU_OWNER {Čeká na uzavření dokumentace SVÚ} SVU_WORKER {Čeká na uzavření dokumentace SVÚ} other {Čeká na uzavření}}',
  },
  [DOC_STATE.WAITING_FOR_CLOSE_FINAL]: {
    id: 'document.state.waitingForCloseFinal',
    defaultMessage: 'Čeká na zapracování dvojic identifikátorů',
  },
  [DOC_STATE.WAITING_FOR_IMPORT]: {
    id: 'document.state.waitingForImport',
    defaultMessage:
      '{id, select, SVU_OWNER {Čeká na import přeshraniční dokumentace SVÚ} other {Čeká na import}}',
  },
  [DOC_STATE.WAITING_FOR_REJECT]: {
    id: 'document.state.waitingForReject',
    defaultMessage: 'Probíhá odmítnutí',
  },
  [DOC_STATE.WAITING_FOR_REJECT_FAILED]: {
    id: 'document.state.waitingForRejectFailed',
    defaultMessage: 'Selhal průběh odmítnutí',
  },
  [DOC_STATE.WAITING_FOR_PROCESS]: {
    id: 'document.state.waitingForProcess',
    defaultMessage: 'Čeká na uzavření',
  },
  [DOC_STATE.WAITING_FOR_SYNCHRONIZE]: {
    id: 'document.state.waitingForSynchronize',
    defaultMessage: 'Čeká na synchronizaci',
  },
  [DOC_STATE.WAITING_FOR_SYNCHRONIZE_DATA]: {
    id: 'document.state.waitingForSynchronizeData',
    defaultMessage: 'Čeká na synchronizační data',
  },
  [DOC_STATE.WAITING_FOR_CHECK_SVU_CROSS_KRAJ]: {
    id: 'document.state.waitingForCheckSvuCrossKraj',
    defaultMessage: 'Čeká na kontrolu PE s krajem',
  },
  [DOC_STATE.REJECTED_BY_COUNTERPART]: {
    id: 'document.state.rejectedByCounterpart',
    defaultMessage:
      '{id, select, CROSS_OWNER {Odmítnutá krajem B} SVU_OWNER {Odmítnuto SVÚ} SVU_CROSS_OWNER {Odmítnutá druhou stranou} other {Odmítnutá druhou stranou}}',
  },
});

export const docRejectedByMessages = defineMessages({
  rejectedBySubjekty: {
    id: 'document.state.rejectedBySubjekty',
    defaultMessage: 'Odmítnuto: {names}',
  },
});

export const docFormMessages = defineMessages({
  state: {
    id: 'docForm.state.label',
    defaultMessage: 'Stav dokumentace',
  },
  id: {
    id: 'docForm.id.label',
    defaultMessage: 'Číslo dokumentace',
  },
  type: {
    id: 'docForm.type.label',
    defaultMessage: 'Typ změny',
  },
  documentation_type: {
    id: 'docForm.documentation_type.label',
    defaultMessage: 'Typ dokumentace',
  },
  geometry_plan_number: {
    id: 'docForm.geometry_plan_number.label',
    defaultMessage: 'Číslo GP',
  },
  buildingCategory: {
    id: 'docForm.buildingCategory.label',
    defaultMessage: 'Kategorie stavby',
  },
  has_planimetry: {
    id: 'docForm.has_planimetry.label',
    defaultMessage: 'Polohopis',
  },
  has_utilities: {
    id: 'docForm.has_utilities.label',
    defaultMessage: 'Inženýrské sítě',
  },
  check_type: {
    id: 'docForm.check_type.label',
    defaultMessage: 'Typ kontroly',
  },
  prejimka_type: {
    id: 'docForm.prejimka_type.label',
    defaultMessage: 'Typ příjmu',
  },
  data_origin: {
    id: 'docForm.data_origin.label',
    defaultMessage: 'Původ dat',
  },
  data_validity: {
    id: 'docForm.data_validity.label',
    defaultMessage: 'Platnost dat',
  },
  name: {
    id: 'docForm.name.label',
    defaultMessage: 'Název',
  },
  owner: {
    id: 'docForm.owner.label',
    defaultMessage: 'Vlastník / investor',
  },
  owner_ico: {
    id: 'docForm.owner_ico.label',
    defaultMessage: 'IČO',
  },
  owner_birth_number: {
    id: 'docForm.owner_birth_number.label',
    defaultMessage: 'RČ',
  },
  processor: {
    id: 'docForm.processor.label',
    defaultMessage: 'Zpracovatel geodetické dokumentace',
  },
  processor_ico: {
    id: 'docForm.processor_ico.label',
    defaultMessage: 'IČO',
  },
  processor_birth_number: {
    id: 'docForm.processor_birth_number.label',
    defaultMessage: 'RČ',
  },
  created: {
    id: 'docForm.created.label',
    defaultMessage: 'Založeno',
  },
  closed: {
    id: 'docForm.closed.label',
    defaultMessage: 'Zpracováno',
  },
  createdGte: {
    id: 'docForm.createdGte.label',
    defaultMessage: 'Vytvořeno po',
  },
  createdLt: {
    id: 'docForm.createdLt.label',
    defaultMessage: 'Vytvořeno před',
  },
  finishedGte: {
    id: 'docForm.finishedGte.label',
    defaultMessage: 'Ukončeno po',
  },
  finishedLte: {
    id: 'docForm.finishedLte.label',
    defaultMessage: 'Ukončeno před',
  },
  closedGte: {
    id: 'docForm.closedGte.label',
    defaultMessage: 'Zpracováno po',
  },
  closedLt: {
    id: 'docForm.closedLt.label',
    defaultMessage: 'Zpracováno před',
  },
  author: {
    id: 'docForm.author.label',
    defaultMessage: 'Uživatel',
  },
  creatorFullName: {
    id: 'docForm.creatorFullName.label',
    defaultMessage: 'Uživatel',
  },
  creatorDtmFullName: {
    id: 'docForm.creatorDtmFullName.label',
    defaultMessage: 'Zpracovatel',
  },
  receiverFullName: {
    id: 'docForm.receiverFullName.label',
    defaultMessage: 'Příjemce',
  },
  receiverName: {
    id: 'docForm.receiverName.label',
    defaultMessage: 'Jméno příjemce',
  },
  receiverSurname: {
    id: 'docForm.receiverSurname.label',
    defaultMessage: 'Přijmení příjemce',
  },
  geodesist: {
    id: 'docForm.geodesist.label',
    defaultMessage: 'Oprávněný geodet',
  },
  cadasters: {
    id: 'docForm.cadasters.label',
    defaultMessage: 'Katastr',
  },
  location: {
    id: 'docForm.location.label',
    defaultMessage: 'Parcely / ulice',
  },
  description: {
    id: 'docForm.description.label',
    defaultMessage: 'Popis',
  },
  note: {
    id: 'docForm.note.label',
    defaultMessage: 'Poznámka',
  },
  utilities_type: {
    id: 'docForm.utilities_type.label',
    defaultMessage: 'Inženýrské sítě',
  },
  attachments: {
    id: 'docForm.attachments',
    defaultMessage: 'Soubory',
  },
  attachments_docs: {
    id: 'docForm.attachments_docs',
    defaultMessage: 'Dokumentační',
  },
  attachments_isdmvs: {
    id: 'docForm.attachments_isdmvs',
    defaultMessage: 'Určené pro druhou stranu',
  },
  attachments_system: {
    id: 'docForm.attachments_system',
    defaultMessage: 'Systémové',
  },
  checks: {
    id: 'docForm.checks',
    defaultMessage: 'Kontroly',
  },
  editor_manager: {
    id: 'docForm.editor_manager.label',
    defaultMessage: 'Editor',
  },
  docAreaTitle: {
    id: 'docForm.areaTitle',
    defaultMessage: 'Oblast změny',
  },
  initialImportDataTypes: {
    id: 'docForm.initialImportDataTypes',
    defaultMessage: 'Varianta dat JVF DTM',
  },
  initialImportId: {
    id: 'docForm.initialImportId',
    defaultMessage: 'Identifikátor změny',
  },
  logs: {
    id: 'docForm.logs',
    defaultMessage: 'Protokol zpracování dokumentace',
  },
  subject: {
    id: 'docForm.subject',
    defaultMessage: 'Subjekt',
  },
  data_type: {
    id: 'docForm.data_type',
    defaultMessage: 'Typ dokumentce',
  },
  dmvs_id_podani: {
    id: 'docForm.dmvs_id_podani',
    defaultMessage: 'ID podání',
  },
  dmvs_id_podani_link: {
    id: 'docForm.dmvs_id_podani_link',
    defaultMessage: 'Zjištění stavu zpracování GAD',
  },
  dmvs_source: {
    id: 'docForm.dmvs_source',
    defaultMessage: 'Zdroj dokumentace',
  },
  dmvs_identifikace_zmeny: {
    id: 'docForm.dmvs_identifikace_zmeny',
    defaultMessage: 'Identifikace změny',
  },
  subjekt_id: {
    id: 'docForm.subjekt_id',
    defaultMessage: 'ID subjektu',
  },
  subjekt_jmeno: {
    id: 'docForm.subjekt_jmeno',
    defaultMessage: 'Subjekt',
  },
  editor_subjekt_id: {
    id: 'docForm.editor_subjekt_id',
    defaultMessage: 'ID editora',
  },
  editor_subjekt_jmeno: {
    id: 'docForm.editor_subjekt_jmeno',
    defaultMessage: 'Editor',
  },
  azi_cislo_opravneni: {
    id: 'docForm.azi_cislo_opravneni',
    defaultMessage: 'AZI číslo oprávnění',
  },
  building_id: {
    id: 'docForm.building_id',
    defaultMessage: 'Číslo stavby zakázky',
  },
  owner_name: {
    id: 'docForm.owner_name',
    defaultMessage: 'Partner/investor',
  },
  processor_name: {
    id: 'docForm.processor_name',
    defaultMessage: 'Zpracovatel',
  },
  processor_organization: {
    id: 'docForm.processor_organization',
    defaultMessage: 'Organizace zpracovatele',
  },
  geodetically_surveyed: {
    id: 'docForm.geodetically_surveyed',
    defaultMessage: 'Datum měření',
  },
  processed: {
    id: 'docForm.processed',
    defaultMessage: 'Datum zpracování',
  },
  verified: {
    id: 'docForm.verified',
    defaultMessage: 'Datum ověření',
  },
  verification_number: {
    id: 'docForm.verification_number',
    defaultMessage: 'Číslo ověření',
  },
  dmvs_rozsahy: {
    id: 'docForm.dmvs_rozsahy',
    defaultMessage: 'Rozsah editace',
  },
  history: {
    id: 'docForm.history',
    defaultMessage: 'Historie stavů',
  },
  processHistory: {
    id: 'docForm.processHistory',
    defaultMessage: 'Historie procesů a stavů',
  },
  latestCheckState: {
    id: 'docForm.latestCheckState',
    defaultMessage: 'Stav kontroly',
  },
  check_source: {
    id: 'docForm.check_source',
    defaultMessage: 'Zdroj kontroly',
  },
  original_id__isnull: {
    id: 'docForm.original_id__isnull',
    defaultMessage: 'DTM',
  },
});

export const docFilterMessages = defineMessages({
  submitBtn: {
    id: 'docFilter.submitBtn.label',
    defaultMessage: 'Filtrovat',
  },
  clearBtn: {
    id: 'docFilter.clearBtn.label',
    defaultMessage: 'Zrušit filtr',
  },
});

export const docUtilitiesTypeMessages = defineMessages<UtilitiesTypeEnum>({
  [UtilitiesTypeEnum.ALL_UTILITIES]: {
    id: 'document.utilities_type.allUtilities',
    defaultMessage: 'Všechny inženýrské sítě',
  },
  [UtilitiesTypeEnum.POWER_LINE]: {
    id: 'document.utilities_type.powerLine',
    defaultMessage: 'Elektrické vedení',
  },
  [UtilitiesTypeEnum.ELECTRONIC_COMMUNICATION]: {
    id: 'document.utilities_type.electronicCommunication',
    defaultMessage: 'Elektronické komunikace',
  },
  [UtilitiesTypeEnum.PIPELINE]: {
    id: 'document.utilities_type.pipeline',
    defaultMessage: 'Plynovod',
  },
  [UtilitiesTypeEnum.WATER_SUPPLY]: {
    id: 'document.utilities_type.waterSupply',
    defaultMessage: 'Vodovod',
  },
  [UtilitiesTypeEnum.WATER_INLETS]: {
    id: 'document.utilities_type.waterInlets',
    defaultMessage: 'Přivaděče vody',
  },
  [UtilitiesTypeEnum.SEWERAGE]: {
    id: 'document.utilities_type.sewerage',
    defaultMessage: 'Kanalizace',
  },
  [UtilitiesTypeEnum.PRODUCT_PIPELINE]: {
    id: 'document.utilities_type.productPipeline',
    defaultMessage: 'Produktovod',
  },
  [UtilitiesTypeEnum.HEAT_PIPE]: {
    id: 'document.utilities_type.heatPipe',
    defaultMessage: 'Teplovod',
  },
  [UtilitiesTypeEnum.TUBE_MAIL]: {
    id: 'document.utilities_type.tubeMail',
    defaultMessage: 'Potrubní pošta',
  },
  [UtilitiesTypeEnum.WASTE_MANAGEMENT]: {
    id: 'document.utilities_type.wasteManager',
    defaultMessage: 'Odpadové hospodářství',
  },
  [UtilitiesTypeEnum.SOIL_AMELIORATION]: {
    id: 'document.utilities_type.soilAmelioration',
    defaultMessage: 'Meliorace',
  },
});

export const docFormTypSubjektuMessages = defineMessages<TypySubjektuEnum>({
  [TypySubjektuEnum.ADMINISTRATOR]: {
    id: 'docForm.rozsah_editace.typSubjektu.administrator',
    defaultMessage: 'Administrátor',
  },
  [TypySubjektuEnum.EDITOR]: {
    id: 'docForm.rozsah_editace.typSubjektu.editor',
    defaultMessage: 'Editor',
  },
  [TypySubjektuEnum.PROVOZOVATEL]: {
    id: 'docForm.rozsah_editace.typSubjektu.provozovatel',
    defaultMessage: 'Provozovatel',
  },
  [TypySubjektuEnum.SPRAVCE]: {
    id: 'docForm.rozsah_editace.typSubjektu.spravce',
    defaultMessage: 'Správce',
  },
  [TypySubjektuEnum.VLASTNIK]: {
    id: 'docForm.rozsah_editace.typSubjektu.vlastnik',
    defaultMessage: 'Vlastník',
  },
  [TypySubjektuEnum.VYJADROVATEL]: {
    id: 'docForm.rozsah_editace.typSubjektu.vyjadrovatel',
    defaultMessage: 'Vyjadřovatel',
  },
});

export const docSVUCrossNamesMessages = defineMessages<SvuCrossNames>({
  [SvuCrossNames.JIHOCESKY_KRAJ]: {
    id: 'docForm.svu.jihocesky_kraj',
    defaultMessage: 'Jihočeský kraj',
  },
  [SvuCrossNames.JIHOMORAVSKY_KRAJ]: {
    id: 'docForm.svu.jihomoravsky_kraj',
    defaultMessage: 'Jihomoravský kraj',
  },
  [SvuCrossNames.KARLOVARSKY_KRAJ]: {
    id: 'docForm.svu.karlovarsky_kraj',
    defaultMessage: 'Karlovarský kraj',
  },
  [SvuCrossNames.KRAJ_VYSOCINA]: {
    id: 'docForm.svu.kraj_vysocina',
    defaultMessage: 'Kraj Vysočina',
  },
  [SvuCrossNames.KRALOVEHRADECKY_KRAJ]: {
    id: 'docForm.svu.kralovehradecky_kraj',
    defaultMessage: 'Královéhradecký kraj',
  },
  [SvuCrossNames.LIBERECKY_KRAJ]: {
    id: 'docForm.svu.liberecky_kraj',
    defaultMessage: 'Liberecký kraj',
  },
  [SvuCrossNames.MORAVSKOSLEZSKY_KRAJ]: {
    id: 'docForm.svu.moravskoslezsky_kraj',
    defaultMessage: 'Moravskoslezský kraj',
  },
  [SvuCrossNames.OLOMOUCKY_KRAJ]: {
    id: 'docForm.svu.olomoucky_kraj',
    defaultMessage: 'Olomoucký kraj',
  },
  [SvuCrossNames.PARDUBICKY_KRAJ]: {
    id: 'docForm.svu.pardubicky_kraj',
    defaultMessage: 'Pardubický kraj',
  },
  [SvuCrossNames.PLZENSKY_KRAJ]: {
    id: 'docForm.svu.plzensky_kraj',
    defaultMessage: 'Plzeňský kraj',
  },
  [SvuCrossNames.REDITELSTVI_SILNIC_A_DALNIC]: {
    id: 'docForm.svu.reditelstvi_silnic_a_dalnic',
    defaultMessage: 'Ředitelství silnic a dálnic s. p.',
  },
  [SvuCrossNames.SPRAVA_ZELEZNIC]: {
    id: 'docForm.svu.sprava_zeleznic',
    defaultMessage: 'Správa železnic, státní organizace',
  },
  [SvuCrossNames.STREDOCESKY_KRAJ]: {
    id: 'docForm.svu.stredocesky_kraj',
    defaultMessage: 'Středočeský kraj',
  },
  [SvuCrossNames.USTECKY_KRAJ]: {
    id: 'docForm.svu.ustecky_kraj',
    defaultMessage: 'Ústecký kraj',
  },
  [SvuCrossNames.ZLINSKY_KRAJ]: {
    id: 'docForm.svu.zlinsky_kraj',
    defaultMessage: 'Zlínský kraj',
  },
});
